import { useState } from 'react'

import { useDidMountEffect } from '@/app/hooks/useLifecycleEffects'
import { cn } from '@/app/utils'
import { HlsPlayer } from '@/components/shared/hls-player'
import Modal, { AppModalProps } from '@/components/shared/modal/ui/Modal'

import { HlsPlayerProps } from '../../hls-player/ui/HlsPlayer'

type HlsPlayerModalProps = {
  modalProps: AppModalProps
  hlsPlayerProps: HlsPlayerProps
}

const modalMarginYHeight = 80
const modaHeaderHeight = 72

const HlsPlayerModal = ({
  modalProps: {
    overlayClassName,
    className: modalClassName,
    style: modalStyle,
    headerWrapperClassName,
    headerClassName,
    closeButtonClassName,
    closeButtonIconClassName,
    contentClassName,
    ...modalProps
  },
  hlsPlayerProps: { className: hlsPlayerClassName, ...hlsPlayerProps }
}: HlsPlayerModalProps) => {
  const [modalWidth, setModalWidth] = useState('auto')

  useDidMountEffect(() => {
    const listenerFn = () => {
      const videoHeight =
        window.innerHeight - (modalMarginYHeight + modaHeaderHeight)
      const videoWidth = (16 * videoHeight) / 9

      setModalWidth(`${videoWidth}px`)
    }

    listenerFn()
    window.addEventListener('resize', listenerFn)

    return () => {
      window.removeEventListener('resize', listenerFn)
    }
  })

  return (
    <Modal
      overlayClassName={cn('xs:!bg-black/50', overlayClassName)}
      className={cn(
        'mx-24 my-40 max-h-[calc(100dvh_-_80px)] sm:mx-0 sm:!h-auto sm:!rounded-0',
        modalClassName
      )}
      style={{ width: modalWidth, ...modalStyle }}
      headerWrapperClassName={cn(
        'pl-32 pb-12 lg:pl-20 lg:pb-8 lg:pt-12 lg:pr-12',
        headerWrapperClassName
      )}
      headerClassName={cn('!text-16', headerClassName)}
      closeButtonClassName={cn('!w-24 !h-24 !p-4', closeButtonClassName)}
      closeButtonIconClassName={cn('!w-16 !h-16', closeButtonIconClassName)}
      contentClassName={cn('m-0 p-0 overflow-y-hidden', contentClassName)}
      {...modalProps}
    >
      <div className="relative aspect-video w-full">
        <HlsPlayer
          className={cn(
            'absolute left-0 top-0 h-full w-full',
            hlsPlayerClassName
          )}
          {...hlsPlayerProps}
        />
      </div>
    </Modal>
  )
}

export default HlsPlayerModal
